var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRightBlue(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.715 12.314a.494.494 0 01-.7-.697l3.594-3.614-3.595-3.62a.494.494 0 01.7-.697l3.587 3.612a1 1 0 010 1.41l-3.586 3.606z",
    fill: "#1B73E8",
    stroke: "#1B73E8",
    strokeWidth: 0.2
  })));
}
export default SvgChevronRightBlue;